export const TALENT_BULK_ACTIONS = new Set([
  "addTags",
  "hide",
  "unhide",
  "duplicate",
]);

const nonAgentSignerCount = (product) =>
  product.fulfillers.filter((fulfiller) => !fulfiller.isAgentShop).length;

export const canBulkSelect = ({ product, isAdmin }) =>
  isAdmin || nonAgentSignerCount(product) < 2;

export const selectableIds = ({ products, isAdmin }) =>
  products
    .filter((product) => canBulkSelect({ product, isAdmin }))
    .map((product) => product.productId);
